<template>
  <el-dropdown trigger="click" @command="handleActions">
    <el-button type="primary" icon="el-icon-setting">
      {{ $t('Audiences_Segment_Dropdown_Settings') }}
      <i class="el-icon-arrow-down el-icon--right" />
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="editSegment" icon="el-icon-edit-outline">
        {{ $t('Audiences_Segment_Action_Edit') }}
      </el-dropdown-item>
      <el-dropdown-item command="copySegment" icon="el-icon-document-copy">
        {{ $t('Audiences_Segment_Action_Copy') }}
      </el-dropdown-item>
      <el-dropdown-item command="deleteSegmentConfirm" icon="el-icon-delete">
        {{ $t('Audiences_Segment_Action_Delete') }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { projectEndpoint, projectRoute } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'

export default {
  components: {},
  props: {
    segment: {
      required: true,
      type: Object
    }
  },
  computed: {
    rowDeleteEndpoint() {
      return projectEndpoint({
        method: 'delete',
        url: `segments/${this.segment.id}`
      })
    }
  },
  methods: {
    rowUpdateRoute() {
      return projectRoute({
        name: 'AudienceRollingSegmentUpdate',
        query: { id: this.segment.id }
      })
    },

    rowCopyRoute() {
      return projectRoute({
        name: 'AudienceRollingSegmentCopy',
        query: { id: this.segment.id }
      })
    },

    confirmDelete() {
      this.$msgbox({
        title: this.$t('Audiences_Segment_DialogDelete_Title'),
        message: this.$t('Audiences_Segment_DialogDelete_Prompt'),
        showCancelButton: true,
        confirmButtonText: this.$t('Audiences_Segment_Button_Confirm'),
        cancelButtonText: this.$t('Audiences_Segment_Button_Cancel'),
        center: true
      }).then(() => {
        this.loading = true
        RestApi(this.rowDeleteEndpoint)
          .then(() => {
            this.$message({
              message: this.$t('Audiences_Segment_Message_DeleteSuccess'),
              type: 'success'
            })

            this.loading = false

            this.$router.push(
              projectRoute({
                name: 'AudienceRollingSegmentList'
              })
            )
          })
          .catch(error => {
            this.$message({
              message: error.message,
              type: 'error'
            })
            this.loading = false
          })
      })
    },
    handleActions(action) {
      switch (action) {
        case 'deleteSegmentConfirm':
          this.confirmDelete()
          break
        case 'editSegment':
          this.$router.push(this.rowUpdateRoute())
          break
        case 'copySegment':
          this.$router.push(this.rowCopyRoute())
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/RollingSegmentSettingsDropdown.vue